import { PayNowProvider } from './paynow';
export { PayNowProvider };
export function getPaymentProvider(method, payeeInfo) {
    switch (method) {
        case 'paynow':
            if (!payeeInfo.paynow) {
                throw new Error('PayNow payee info is required');
            }
            return new PayNowProvider(payeeInfo.paynow);
        // Future cases for other providers
        // case 'duitnow':
        //   return new DuitNowProvider(payeeInfo.duitnow);
        default:
            throw new Error(`Unsupported payment method: ${method}`);
    }
}
